const translation = {
  daysInWeek: {
    Mon: 'Môn',
    Sat: 'Ngồi',
    Wed: 'Thứ Tư',
    Sun: 'Mặt trời',
    Tue: 'Thứ Ba',
    Fri: 'Thứ Sáu',
    Thu: 'Thu',
  },
  months: {
    April: 'Tháng Tư',
    June: 'Tháng Sáu',
    September: 'Tháng Chín',
    March: 'Tháng Ba',
    February: 'Tháng Hai',
    August: 'Tháng Tám',
    May: 'Tháng Năm',
    October: 'Tháng Mười',
    December: 'Tháng Mười Hai',
    January: 'Tháng Một',
    July: 'Tháng Bảy',
    November: 'Tháng Mười Một',
  },
  operation: {
    ok: 'Được rồi',
    pickDate: 'Chọn Ngày',
    now: 'Bây giờ',
    cancel: 'Hủy bỏ',
  },
  title: {
    pickTime: 'Chọn Thời Gian',
  },
  defaultPlaceholder: 'Chọn một thời gian...',
}

export default translation
